// Brand-level constants for Ricatto Metais.
// All phone numbers and address use placeholder values that the owner
// can update in one place. WhatsApp link is built with click-to-chat.

export const BRAND = {
  name: "Ricatto Metais",
  legalName: "Reciclagem Ricatto",
  tagline: "Compra de alumínio e cobre em Maringá-PR",
  city: "Maringá",
  state: "PR",
  region: "Maringá e região",
  // International format without "+" for wa.me click-to-chat.
  whatsappNumber: "5544999004425",
  phoneDisplay: "(44) 99900-4425",
  email: "contato@ricattometais.com.br",
  addressLine: "Rua José Toral Querubim, 41 — Conjunto Guaipó, Maringá-PR",
  addressCep: "87047-438",
  hours: "Seg a Sex: 08h–18h · Sáb: 08h–12h",
  mapsEmbed:
    "https://www.google.com/maps?q=Reciclagem+Ricatto+Rua+Jos%C3%A9+Toral+Querubim%2C+41+Conjunto+Guaip%C3%B3+Maring%C3%A1+PR+87047-438&output=embed",
  mapsRoute:
    "https://www.google.com/maps/dir/?api=1&destination=Reciclagem+Ricatto+Rua+Jos%C3%A9+Toral+Querubim%2C+41+Conjunto+Guaip%C3%B3+Maring%C3%A1+PR+87047-438",
};

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(
    message || "Olá! Quero enviar a foto do meu material para avaliação.",
  );
  return `https://wa.me/${BRAND.whatsappNumber}?text=${text}`;
};

export const MATERIALS = [
  {
    id: "aluminio",
    title: "Alumínio Bloco",
    desc: "Panelas, peças fundidas e refugos de alumínio em geral.",
    img: "https://images.pexels.com/photos/27312903/pexels-photo-27312903.jpeg",
  },
  {
    id: "latinhas",
    title: "Latinhas",
    desc: "Latas de alumínio limpas, prensadas ou soltas.",
    img: "https://images.pexels.com/photos/802221/pexels-photo-802221.jpeg",
  },
  {
    id: "perfil",
    title: "Perfil de Alumínio",
    desc: "Esquadrias, perfis de janela, portas e fachadas.",
    img: "https://images.pexels.com/photos/2244746/pexels-photo-2244746.jpeg",
  },
  {
    id: "cobre-limpo",
    title: "Cobre Limpo",
    desc: "Cobre brilhante, sem oxidação e sem isolamento.",
    img: "https://images.pexels.com/photos/5279317/pexels-photo-5279317.jpeg",
  },
  {
    id: "cobre-encapado",
    title: "Cobre Encapado",
    desc: "Fios e cabos de cobre com capa plástica.",
    img: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg",
  },
  {
    id: "sucata-cobre",
    title: "Cabos & Sucata de Cobre",
    desc: "Motores, bobinas, transformadores e sucata em geral.",
    img: "https://images.pexels.com/photos/162568/oil-pump-jack-sunset-clouds-silhouette-162568.jpeg",
  },
];

export const TRUST_ITEMS = [
  {
    icon: "Money",
    title: "Pagamento na hora",
    desc: "Pesou, fechou, pagou. Sem promessas vazias.",
  },
  {
    icon: "Scales",
    title: "Pesagem justa",
    desc: "Balança aferida e conferência aberta com o cliente.",
  },
  {
    icon: "Truck",
    title: "Retirada rápida",
    desc: "Buscamos em Maringá e região com agilidade.",
  },
  {
    icon: "ShieldCheck",
    title: "Empresa séria",
    desc: "Atendimento direto, transparente e sem enrolação.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Carlos R.",
    where: "Zona Sul, Maringá",
    quote:
      "Levei umas latinhas e perfis de alumínio, pesaram na minha frente e pagaram na hora. Empresa de confiança.",
  },
  {
    name: "Aline M.",
    where: "Sarandi",
    quote:
      "Tinha sucata de cobre da reforma. Combinei pelo WhatsApp e em duas horas estavam no portão. Atendimento top.",
  },
  {
    name: "José P.",
    where: "Centro, Maringá",
    quote:
      "Pago melhor que outros lugares que pesquisei. Recomendo para quem quer preço honesto.",
  },
  {
    name: "Marcos T.",
    where: "Maringá Velho",
    quote:
      "Mandei a foto pelo WhatsApp, já me deram uma estimativa. Quando cheguei lá, o preço bateu certinho.",
  },
];

export const FAQ = [
  {
    q: "Qual o preço do alumínio e do cobre hoje?",
    a: "O preço varia diariamente conforme o mercado. Mande uma foto pelo WhatsApp que retornamos a cotação atualizada na hora.",
  },
  {
    q: "Vocês fazem retirada do material?",
    a: "Sim. Atendemos com retirada em Maringá e região. Combine pelo WhatsApp informando bairro e quantidade aproximada.",
  },
  {
    q: "Compram pouca quantidade?",
    a: "Compramos. De alguns quilos a cargas maiores. Para retirada, há uma quantidade mínima — confirme antes pelo WhatsApp.",
  },
  {
    q: "Como funciona a pesagem?",
    a: "Pesamos o material na sua frente, com balança aferida. Você vê o número, fechamos o preço e pagamos na hora.",
  },
  {
    q: "Vocês compram ferro?",
    a: "Não. Trabalhamos exclusivamente com alumínio e cobre em suas variações. Foco em metais não-ferrosos.",
  },
  {
    q: "Quais formas de pagamento?",
    a: "Dinheiro, PIX ou transferência. Você escolhe na hora.",
  },
];

export const GALLERY = [
  {
    src: "https://images.pexels.com/photos/5279317/pexels-photo-5279317.jpeg",
    alt: "Cobre encapado e cabos",
  },
  {
    src: "https://images.pexels.com/photos/27312903/pexels-photo-27312903.jpeg",
    alt: "Alumínio em pátio",
  },
  {
    src: "https://images.pexels.com/photos/16615215/pexels-photo-16615215.jpeg",
    alt: "Balança industrial",
  },
  {
    src: "https://images.unsplash.com/photo-1701637657912-9e23e32155d1?w=1200&q=80",
    alt: "Caminhão de retirada",
  },
  {
    src: "https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg",
    alt: "Fios de cobre encapados",
  },
  {
    src: "https://images.pexels.com/photos/162553/keys-workshop-mechanic-tools-162553.jpeg",
    alt: "Ferramentas e operação",
  },
];
